import { createReducer } from "@reduxjs/toolkit";
import { Types } from "./Actions";
import INITIAL_STATE from "./InitialState";

export const AseguradoReducer = createReducer(INITIAL_STATE, (builder) => {
  /**
   * Consultar datos de un asegurado
   */
  builder
    .addCase(Types.CONSULTAR_ASEGURADO_LOADING, (state) => {
      state.consultarAseguradoLoading = true;
      state.consultarAseguradoError = null;
    })
    .addCase(Types.CONSULTAR_ASEGURADO_SUCCESS, (state, action) => {
      const { consultarAseguradoData } = action;
      state.consultarAseguradoData = consultarAseguradoData;
      state.consultarAseguradoLoading = false;
      state.limpiarDatosAseguradoLoading = false;
      state.consultarAseguradoError = null;
    })
    .addCase(Types.CONSULTAR_ASEGURADO_FAILURE, (state, action) => {
      const { consultarAseguradoError } = action;
      state.consultarAseguradoData = INITIAL_STATE.consultarAseguradoData;
      state.consultarAseguradoLoading = false;
      state.limpiarDatosAseguradoLoading = false;
      state.consultarAseguradoError = consultarAseguradoError;
    });

  /**
   * Limpiar datos del asegurado
   */
  builder.addCase(Types.LIMPIAR_DATOS_ASEGURADO_LOADING, (state) => {
    state.limpiarDatosAseguradoLoading = true;
  });
});
